import * as React from 'react'

function SvgLocationIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="LocationIcon_svg__a"
        maskUnits="userSpaceOnUse"
        x={5}
        y={1.35}
        width={22}
        height={29}
        fill="#000"
      >
        <path fill="#fff" d="M5 1.35h22v29H5z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 27.65s9-7.947 9-14.44c0-5.445-4.03-9.86-9-9.86s-9 4.415-9 9.86c0 6.493 9 14.44 9 14.44zm0-11.7a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 27.65s9-7.947 9-14.44c0-5.445-4.03-9.86-9-9.86s-9 4.415-9 9.86c0 6.493 9 14.44 9 14.44zm0-11.7a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2z"
        fill="currentColor"
      />
      <path
        d="M16 27.65l-1.06 1.2 1.06.934 1.06-.935L16 27.65zm7.4-14.44c0 1.273-.448 2.729-1.232 4.27-.777 1.527-1.831 3.034-2.915 4.382a42.557 42.557 0 01-4.227 4.512 10.016 10.016 0 01-.085.077L16 27.65l1.06 1.199.003-.003.006-.006.024-.02.083-.076a42.06 42.06 0 001.364-1.308 45.77 45.77 0 003.207-3.569c1.166-1.45 2.362-3.146 3.273-4.936.903-1.774 1.58-3.747 1.58-5.72h-3.2zM16 4.95c3.953 0 7.4 3.558 7.4 8.26h3.2c0-6.188-4.611-11.46-10.6-11.46v3.2zm-7.4 8.26c0-4.702 3.447-8.26 7.4-8.26v-3.2c-5.989 0-10.6 5.272-10.6 11.46h3.2zM16 27.65l1.06-1.199-.004-.003a42.557 42.557 0 01-4.31-4.586c-1.083-1.348-2.137-2.855-2.914-4.382-.784-1.541-1.232-2.997-1.232-4.27H5.4c0 1.974.677 3.947 1.58 5.721.91 1.79 2.107 3.486 3.273 4.936a45.77 45.77 0 004.571 4.877l.083.075.024.021.006.006.003.002L16 27.65zm2-15.3a2 2 0 01-2 2v3.2a5.2 5.2 0 005.2-5.2H18zm-2-2a2 2 0 012 2h3.2a5.2 5.2 0 00-5.2-5.2v3.2zm-2 2a2 2 0 012-2v-3.2a5.2 5.2 0 00-5.2 5.2H14zm2 2a2 2 0 01-2-2h-3.2a5.2 5.2 0 005.2 5.2v-3.2z"
        fill="#fff"
        mask="url(#LocationIcon_svg__a)"
      />
    </svg>
  )
}

export default SvgLocationIcon
